/* eslint-disable eqeqeq */
import React from "react";
import NavigationBar from "../../_components/AccessoryFinder/NavigationBar/NavigationBar";
import HomeHead from "../../_components/AccessoryFinder/HomeHead/HomeHead";
import Footer from "../../_components/AccessoryFinder/Footer/Footer";
import * as Constants from "../../_constants/accessoryfinder.constants";
import ResultView from "../../_components/AccessoryFinder/ResultView/ResultView";
import Introduction from "../../_components/AccessoryFinder/Introduction/Introduction";
import accessoryfinderService from "../../_services/accessoryfinder.service";
import ResultTitle from "../../_components/AccessoryFinder/ResultView/ResultTitle/ResultTitle";
import Contact from "../../_components/AccessoryFinder/Contact/Contact";
import Help from "../../_components/AccessoryFinder/Help/Help";
import "../AccessoryFinder/AccessoryFinder.css";
import customFunction from "../../customFunction/customFunction";
import ShopWalmart from "../../_components/ShopWalmart/ShopWalmart";

class AccessoryFinder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      checkedValue: Constants.ACCESSORIES,
      isAccessories: true,
      isLoading: false,
      error: null,
      cssClass: "navbar navbar-expand-lg appHeader",

      vacuumModelSelectedValue: "",
      vacuumModelData: [],

      modelSeriesSelectedValue: "",
      modelSeriesData: [],

      productSelectedValue: "",
      productData: [],

      brandSelectedValue: "",
      brandData: [],

      AccessoriesDetailData: [],
      ProductDetailData: [],

      isResult: false,
      isRecorsFound: false,
      resultType: "",

      isValidForm: false,
      errors: {},
      title: "",
    };

    this.ddlVacuumModeOnChange = this.ddlVacuumModeOnChange.bind(this);
    this.ddlModelSeriesOnChange = this.ddlModelSeriesOnChange.bind(this);
    this.ddlproductOnChange = this.ddlproductOnChange.bind(this);
    this.ddlBrandOnChange = this.ddlBrandOnChange.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.onRadioChange = this.onRadioChange.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
    this.getBrand();
    this.getAllAccessories();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  onMenuclick = (dvId) => () => {
    customFunction.goTo(dvId);
    this.setState({ isOpen: !this.state.isOpen });
  };

  handleScroll(e) {
    const pageYOffset =
      window.pageYOffset || document.documentElement.scrollTop;
    if (pageYOffset > 10) {
      this.setState({ cssClass: "navbar navbar-expand-lg appHeader blue" });
    } else {
      this.setState({ cssClass: "navbar navbar-expand-lg appHeader" });
    }
  }

  toggleOpen = () => this.setState({ isOpen: !this.state.isOpen });
  ddlBrandOnChange = (e) => {
    const { errors } = this.state;
    this.setState({
      brandSelectedValue: e.target.value,
      vacuumModelData: [],
      modelSeriesData: [],
      modelSeriesSelectedValue: "",
      vacuumModelSelectedValue: "",
      errors: { ...errors, brandError: "" },
    });
    if (e.target.value != "") {
      this.getVacuumModelsByBrand(e.target.value);
    }
  };
  ddlVacuumModeOnChange = (e) => {
    const { errors } = this.state;
    this.setState({
      modelSeriesData: [],
      modelSeriesSelectedValue: "",
      vacuumModelSelectedValue: e.target.value,
      isValidForm: e.target.value === "" ? false : true,
      vacuumModelErrorClass: e.target.value === "" ? "invalid-home" : "",
      errors: { ...errors, vacuumModelError: "" },
    });
    if (e.target.value != "") {
      this.getModelSeries(e.target.value);
    }
  };
  ddlModelSeriesOnChange = (e) => {
    const { errors } = this.state;
    this.setState({
      modelSeriesSelectedValue: e.target.value,
      errors: { ...errors, modelSeriesError: "" },
    });
  };
  ddlproductOnChange = (e) => {
    const { errors } = this.state;
    this.setState({
      productSelectedValue: e.target.value,
      errors: { ...errors, productError: "" },
    });
  };
  onRadioChange = (e) => {
    let _isAccessories;
    if (e.target.value == Constants.ACCESSORIES) {
      _isAccessories = true;
    } else {
      _isAccessories = false;
    }
    this.setState({
      errors: {},
      isResult: false,
      checkedValue: e.target.value,
      isAccessories: _isAccessories,
      brandSelectedValue: "",
      modelSeriesSelectedValue: "",
      vacuumModelSelectedValue: "",
      productSelectedValue: "",
    });
  };

  handleClick = (e) => {
    if (this.state.checkedValue === Constants.ACCESSORIES) {
      if (this.validateForm()) {
        this.getAccessoriesDetail(
          this.state.vacuumModelSelectedValue,
          this.state.modelSeriesSelectedValue
        );
      }
    } else {
      if (this.validateForm()) {
        this.getProductDetailData(this.state.productSelectedValue);
      }
    }
  };

  labelClick = (value) => {
    let _isAccessories;
    if (value == Constants.ACCESSORIES) {
      _isAccessories = true;
    } else {
      _isAccessories = false;
    }
    this.setState({
      isResult: false,
      checkedValue: value,
      isAccessories: _isAccessories,
      brandSelectedValue: "",
      modelSeriesSelectedValue: "",
      vacuumModelSelectedValue: "",
      productSelectedValue: "",
    });
  };
  getBrand = () => {
    accessoryfinderService
      .getAllBrands()
      .then((data) => this.responseShow(data, "brandData"))
      .catch((error) => console.log("Error :" + error));
  };
  getVacuumModelsByBrand = (id) => {
    accessoryfinderService
      .getVacuumModelsByBrand(id)
      .then((data) => this.responseShow(data, "vacuumModels"))
      .catch((error) => console.log("Error :" + error));
  };
  getModelSeries = (id) => {
    accessoryfinderService
      .getModelSeries(id)
      .then((data) => this.responseShow(data, "modelSeries"))
      .catch((error) => console.log("Error :" + error));
  };
  getAllAccessories = () => {
    accessoryfinderService
      .getAllAccessories()
      .then((data) => this.responseShow(data, "allAccessories"))
      .catch((error) => console.log("Error :" + error));
  };

  getAccessoriesDetail = (modelID, seriesId) => {
    let _seriesId = seriesId === "" ? 0 : seriesId;
    const model = {
      ModelID: parseInt(modelID),
      SeriesID: parseInt(_seriesId),
    };
    let formData = JSON.stringify(model);

    accessoryfinderService
      .getAccessoriesDetail(formData)
      .then((data) => {
        this.responseShow(data, "accessoriesDetail");
      })
      .catch((error) => console.log("Error :" + error));
  };
  getProductDetailData = (accessoryId) => {
    const model = {
      AccessoryID: parseInt(accessoryId),
    };
    let formData = JSON.stringify(model);

    accessoryfinderService
      .getProductDetail(formData)
      .then((data) => this.responseShow(data, "productDetail"))
      .catch((error) => console.log("Error :" + error));
  };

  responseShow(obj, targetarr) {
    if (obj.isSuccess) {
      if (targetarr === "brandData") {
        this.setState({ brandData: obj.data });
      }
      if (targetarr === "vacuumModels") {
        this.setState({ vacuumModelData: obj.data });
      }
      if (targetarr === "modelSeries") {
        this.setState({ modelSeriesData: obj.data });
      }
      if (targetarr === "allAccessories") {
        this.setState({ productData: obj.data });
      }
      if (targetarr === "accessoriesDetail") {
        let isResult = true;
        let isRecorsFound = false;

        if (obj.data && obj.data.length > 0) {
          isRecorsFound = true;
          // isResult = true;
        }
        let headerTitle = this.getTitle();
        customFunction.goTo("#searchResult");
        this.setState({
          AccessoriesDetailData: obj.data,
          resultType: Constants.ACCESSORIES,
          isResult: isResult,
          isRecorsFound: isRecorsFound,
          title: headerTitle,
        });
      }
      if (targetarr === "productDetail") {
        let isResult = true;
        let isRecorsFound = false;

        if (obj.data && obj.data.length > 0) {
          isRecorsFound = true;
          // isResult = true;
        }
        let headerTitle = this.getTitle();
        customFunction.goTo("#searchResult");
        this.setState({
          ProductDetailData: obj.data,
          resultType: Constants.VACUUMMODEL,
          isResult: isResult,
          isRecorsFound: isRecorsFound,
          title: headerTitle,
        });
      }
    }
  }

  validateForm() {
    let {
      brandSelectedValue,
      vacuumModelSelectedValue,
      modelSeriesSelectedValue,
      modelSeriesData,
      productSelectedValue,
      checkedValue,
    } = this.state;
    let errors = {};
    let isFormValid = true;

    if (checkedValue === Constants.ACCESSORIES) {
      if (!brandSelectedValue) {
        isFormValid = false;
        errors["brandError"] = "Please Select Brand";
      }
      if (!vacuumModelSelectedValue) {
        isFormValid = false;
        errors["vacuumModelError"] = "Please Select Vacuum Model";
      }
      if (
        !modelSeriesSelectedValue &&
        modelSeriesData &&
        modelSeriesData.length > 0
      ) {
        isFormValid = false;
        errors["modelSeriesError"] = "Please Select Vacuum Model Series";
      }
    } else {
      if (!productSelectedValue) {
        isFormValid = false;
        errors["productError"] = "Please Select Product";
      }
    }
    this.setState({
      errors: errors,
    });
    return isFormValid;
  }

  getTitle() {
    const {
      brandSelectedValue,
      brandData,
      vacuumModelData,
      modelSeriesData,
      vacuumModelSelectedValue,
      modelSeriesSelectedValue,
      productSelectedValue,
      productData,
      checkedValue,
    } = this.state;
    let message = "";
    if (checkedValue === Constants.ACCESSORIES) {
      if (brandSelectedValue != "") {
        let list = brandData.filter((u) => u.value == brandSelectedValue);
        message = list[0].text;
      }
      if (vacuumModelSelectedValue != "") {
        let list = vacuumModelData.filter(
          (u) => u.value == vacuumModelSelectedValue
        );
        message = message + ", " + list[0].text;
      }
      if (modelSeriesSelectedValue != "") {
        let list = modelSeriesData.filter(
          (u) => u.value == modelSeriesSelectedValue
        );
        message = message + ", " + list[0].text;
      }
    } else {
      if (productSelectedValue != "") {
        let list = productData.filter((u) => u.value == productSelectedValue);
        message = list[0].text;
      }
    }
    return message;
  }

  render() {
    const showClass = `collapse navbar-collapse${
      this.state.isOpen ? " show" : ""
    }`;
    const { isResult, isRecorsFound, cssClass, checkedValue } = this.state;

    return (
      <React.Fragment>
        <NavigationBar
          onMenuclick={this.onMenuclick}
          _toggleOpen={this.toggleOpen}
          menuClass={showClass}
          menuList={Constants.MENU}
          cssClass={cssClass}
        />
        <HomeHead
          labelClick={this.labelClick}
          errors={this.state.errors}
          checkedValue={checkedValue}
          onRadioChange={this.onRadioChange}
          isAccessories={this.state.isAccessories}
          vacuumModelData={this.state.vacuumModelData}
          vacuumModelSelectedValue={this.state.vacuumModelSelectedValue}
          ddlVacuumModeOnChange={this.ddlVacuumModeOnChange}
          modelSeriesData={this.state.modelSeriesData}
          modelSeriesSelectedValue={this.state.modelSeriesSelectedValue}
          brandData={this.state.brandData}
          brandSelectedValue={this.state.brandSelectedValue}
          ddlBrandOnChange={this.ddlBrandOnChange}
          ddlModelSeriesOnChange={this.ddlModelSeriesOnChange}
          productData={this.state.productData}
          productSelectedValue={this.state.productSelectedValue}
          ddlproductOnChange={this.ddlproductOnChange}
          handleClick={this.handleClick}
        />

        <div className="container">
          <div className="pt-2" id="searchResult">
            {isResult && isRecorsFound ? (
              <ResultTitle title={this.state.title} />
            ) : null}
            {isResult ? (
              <ResultView
                title={this.state.title}
                resultType={this.state.resultType}
                AccessoriesDetailData={this.state.AccessoriesDetailData}
                ProductDetailData={this.state.ProductDetailData}
              />
            ) : null}
          </div>
          <ShopWalmart />
          <Introduction />
          <Help />
          <Contact />
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

export default AccessoryFinder;
